import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const ViewModal = ({ handleEditModalClose, cnfrmtext, data }) => {
  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between">
            <p className="fs-4 fw-medium m-0">{cnfrmtext}</p>
            <span className="bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                size={25}
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <p className="fs-7 fw-normal w-100">{data}</p>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewModal;
